
export function getBlogRow(blog: any, index: any)
{
    var blogRow = `<div class="blog-row">
      <div class="container">
        <div class="row">
            <div class="col-md-8">
                 <div class="blog-txt">
                      <h2 id ="articleTitle${index}" class="primary-title primary-theme-clr text-xlg">${blog.custom_s_heading}</h2>
                      <p class="body-text grey-clr" id="articleSummary${index}">${blog.custom_t_content_summary_Desc} […]</p>
                      <a id="articleHref${index}" href="${blog.custom_s_local_url}" class="link-text text-sm primary-theme-clr" aria-label="Read More">Read More</a>
            </div>
                    </div>
                <div class="col-md-4">
                    <div class="blog-img"> <img id="articleSummaryImage${index}" class="img-fluid" src="${blog.custom_s_article_summary_Image_url}" alt="${blog.custom_t_content_summary_Image_url_alt}" loading="lazy"  width="370" height="210"> </div>
                 </div>
            </div>
        </div>
    </div>`;
    if(blog.custom_s_article_summary_Image_url === undefined || blog.custom_s_article_summary_Image_url ===""){
        blogRow = `<div class="blog-row">
        <div class="container">
          <div class="row">
              <div class="col-md-12">
                   <div class="blog-txt">
                        <h2 id ="articleTitle${index}" class="primary-title primary-theme-clr text-xlg">${blog.custom_s_heading}</h2>
                        <p class="body-text grey-clr" id="articleSummary${index}">${blog.custom_t_content_summary_Desc} […]</p>
                        <a id="articleHref${index}" href="${blog.custom_s_local_url}" class="link-text text-sm primary-theme-clr" aria-label="Read More">Read More</a>
                    </div>
                </div>
            </div>
          </div>
      </div>`;
    }
    return blogRow;
}
